export const settings = {
  // Page
  pageTitle: "Account settings",
  pageSubtitle: "Customize your reading experience, profile, and account.",
  back: "Back",

  // About yourself
  aboutYourself: "About yourself",
  changeAvatar: "Change avatar",
  avatarHint: "JPG, PNG or GIF. Recommended 200x200px.",
  username: "Username",
  usernamePrefix: "globalcomix.com/u/",
  usernameHint: "{{max}} characters max. Letters, numbers, and hyphens only.",
  fullName: "Full name",
  fullNamePlaceholder: "Your full name",
  fullNameHint: 'Used when we contact you directly. Never shown publicly unless you enable "Display real name" below.',
  fullNameRequired: "Full name is required",
  fullNameRequiredHint: "Add your full name before saving your profile.",
  shortBio: "Short bio",
  bioPlaceholder: "Tell others a bit about yourself...",
  saveProfile: "Save profile",
  unsupportedAvatarFile: "Unsupported avatar file",
  unsupportedAvatarHint: "Use PNG, JPG, GIF, or TIFF.",
  avatarUploadFailed: "Avatar upload failed",
  avatarUploadFailedHint: "Please try again.",

  // Crop modal
  cropAvatar: "Crop avatar",
  upload: "Upload",
  cancel: "Cancel",

  // Discovery & content
  discoveryContent: "Discovery & content",
  showMatureContent: "Show mature content",
  showMatureContentDesc: "Enable access to explicit and mature-rated comics. You must be 18 or older.",
  hideAiContent: "Hide AI-generated content",
  hideAiContentDesc: "Exclude AI-generated comics from search results and recommendations.",

  // Language & locale
  languageLocale: "Language & locale",
  country: "Country",
  selectCountry: "Select country",
  interfaceLanguage: "Interface language",
  preferredReadingLanguage: "Preferred reading language",
  anyLanguage: "Any language",
  readingLanguageHint: "When available, comics will default to this language.",

  // Privacy
  privacy: "Privacy",
  showRealName: "Show real name on profile",
  showRealNameDesc: "Display your full name publicly alongside your username.",
  showDonations: "Show donation amounts",
  showDonationsDesc: "Include the amount when donations appear on your profile.",
  allowDMs: "Allow direct messages",
  allowDMsDesc: "Let other users start conversations with you. You can still message others when this is off.",

  // Email notifications
  emailNotifications: "Email notifications",

  // Beta
  betaParticipation: "Beta participation",
  betaOptIn: "Opt-in to test beta features",
  betaOptInDesc: "Get early access to new features. We'll keep you in the loop about what has changed and ask for your feedback.",

  // Change email
  changeEmail: "Change email",
  emailAddress: "Email address",
  emailPlaceholder: "your@email.com",
  emailHint: "Used for account recovery and notifications.",
  currentPassword: "Current password",
  currentPasswordPlaceholder: "Enter your current password",
  updateEmail: "Update email",

  // Change password
  changePassword: "Change password",
  newPassword: "New password",
  newPasswordPlaceholder: "Enter new password",
  passwordMinLength: "Minimum 6 characters.",
  confirmNewPassword: "Confirm new password",
  confirmPasswordPlaceholder: "Re-enter new password",
  passwordsMismatch: "Passwords do not match.",

  // Credits
  creditsPromoCodes: "Credits & promo codes",
  enterPromoCode: "Enter a promo or gift code",
  promoPlaceholder: "e.g. ABCD-1234",
  promoHint: "Redeem promo codes, gift cards, and credit codes here.",
  claimCode: "Claim code",
};
